import { ID, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { ILand } from "src/modules/pe-fest-module/data/interfaces"
import { Button, ButtonGroup, Icon, Intent, Popover, Position } from "@blueprintjs/core" 

/* Protopia Ecosystem component */
export interface IClasterMenuProps {
   items: ILand[]
   current: ILand
   onClick: ( item: ILand ) =>void
}
const ClusterMenu = ({current, onClick, ...props}: IClasterMenuProps): JSX.Element => {
    const {width} = useScreenSize()

    let itemIDs: ID[] =[]
    return width > WINDOW_WIDTH.TABLET
        ?
        <div className="topos-dmap-dialog-menu overflow-y-auto">
            <ButtonGroup vertical className="w-100">                    
            {
                props.items.map((item, i) => {
                    if( itemIDs.includes(item.id )) return null
                    itemIDs.push(item.id)
                    return <ButtonScreen current={ current } item={ item } onClick={ onClick } key={ item.id } /> 
                })
            }
            </ButtonGroup>
        </div>
        :
        <div className="topos-dmap-dialog-menu ">
            <ButtonMobile current={ current } item={ current } onClick={ onClick } items={ props.items } />
        </div>
}
export default ClusterMenu

const ButtonScreen = ({current, item, onClick, ...props}: any) : JSX.Element => {
    return <Button 
        minimal={current.id !== item.id} 
        fill 
        className="py-3 px-3 text-light btn-stretch small-button"
        alignText="right"  
        intent={current.id === item.id ? Intent.DANGER : Intent.NONE}
        onClick={() => onClick( item )}
    >
        <span className="text-overflow">
            <span>{item.title}</span> 
        </span> 
    </Button>
}

const ButtonMobile = ({current, item, onClick, ...props}: any) : JSX.Element => {
    const {width} = useScreenSize()
    return <Popover
        position={Position.BOTTOM}
        className="w-100 " 
        content={
            <ButtonGroup vertical className="w-100 overflow-y-auto h-275">                    
            {
                props.items.map((item:ILand ) => { 
                    return <Button 
                        key={item.id}
                        minimal={current.id !== item.id} 
                        fill 
                        className="py-4 px-3 text-light btn-stretch"
                        style={{ width : width - 40 }}
                        alignText="right"  
                        intent={current.id === item.id ? Intent.DANGER : Intent.NONE}
                        onClick={() => onClick( item )}
                    >
                        <span className=" w-100 ">
                            <span className="small">{item.title}</span> 
                        </span> 
                    </Button>
                })
            }
            </ButtonGroup>
        }
    >
        <Button 
            minimal={current.id !== item.id} 
            fill 
            className="py-1 px-3 text-light btn-stretch "
            alignText="right"  
            intent={current.id === item.id ? Intent.DANGER : Intent.NONE}
            //onClick={() => onClick( item )}
        >
            <span className="text-overflow small">
                <span>{item.title}</span> 
            </span> 
            <span className="position-absolute top right mt-1 mr-3">
                <Icon icon='chevron-down' size={22} />
            </span>
        </Button>
    </Popover>
}